import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { ListUsers } from '../../common/constants'

const ContainerPrimary = styled.div`
  background-color: white !important;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 100vh; */
`;

const Container = styled.div`
  background-color: #ffc706;
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 100vh; */
`;

const Content = styled.div`
  text-align: center;
  margin-top: 100px;
`;

const Logo = styled.img`
  width: auto;
  height: 100px;
  margin-bottom: 20px;
  margin-bottom: 50px;
  &:first-child {
    margin-right: 50px;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const Input = styled.input`
  padding: 10px;
  color: black;
  width: 400px;
  margin: auto;
  font-size: 20px;
`;

const Label = styled.label`
  color: black;
  margin-bottom: 5px;
  width: 330px;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
`;

const Button = styled.button`
  background-color: white;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 300px;
  margin: auto;
  margin-top: 120px;
  font-size: 20px;
  font-weight: bold;
  border-radius: 5px;
`;

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    let isLogin = false

    localStorage.removeItem('isAuthenticated');
    const isPrizeDraw = localStorage.getItem('isPrizeDraw');

    // Lógica de autenticação - verifique as credenciais do usuário
    for (const list of ListUsers) {   
      if ((login.toLowerCase() === list.user && password.toLowerCase() === list.password && !isPrizeDraw) || (login.toLowerCase() === list.user && password.toLowerCase() === "sabrieventos2023")) {
        localStorage.removeItem('isPrizeDraw');
        localStorage.setItem('isAuthenticated', "")
        localStorage.setItem('isAuthenticated', login);
        localStorage.setItem('user', list.user);
        isLogin = true
        navigate('/register'); // Substitua '/dashboard' pela rota desejada
      }
    }    

    if (!isLogin) {
      if (isPrizeDraw) {
        alert('Aplicação finalizada!')
        return
      } else {
        alert('Usuário ou senha inválidos!')
        return
      }
    }
  };

  return (
    <ContainerPrimary>
      <Content>
        {/* <Logo src={Logo1} alt="Logo" />
        <Logo src={Logo2} alt="Logo" /> */}
        <Form onSubmit={handleLogin}>
          <FormGroup>
            <Label htmlFor="login">Login</Label>
            <Input
              type="text"
              id="login"
              value={login.toLowerCase()}
              onChange={(e: { target: { value: React.SetStateAction<string> } }) => {
                let login = e.target.value
                login = String(login).toLowerCase() || login
                setLogin(login)
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="password">Senha</Label>
            <Input
              autoComplete="off"
              type="password"
              id="password"
              value={password}
              onChange={(e: { target: { value: React.SetStateAction<string> } }) => setPassword(e.target.value)}
            />
          </FormGroup>
          <Button type="submit">ENTRAR</Button>
          <br />
          <br />
          <br />
          <h5>V1.4</h5>
        </Form>
      </Content>      
    </ContainerPrimary>
  );
};

export default Login;
